import { useFluxStore } from '@evertrue/et-flux';
import DNAStore from 'base/dna/dna-store';
import FeatureStore from 'apps/layout/stores/feature-store';

const featureStoreMapState = () => {
  return {
    hasCustomFields: FeatureStore.hasFeature('proposal_custom_fields'),
    hasProposalReporting: FeatureStore.hasFeature('proposal_reported'),
    isDesignationInDollars: FeatureStore.hasFeature('proposal_designation_dollars'),
  };
};

const DNAStoreMapState = () => {
  return {
    solicitorLimit: 1 + Number(DNAStore.getByKey('proposal-export-fixed-number-of-solicitors')),
    additionalContactLimit: Number(DNAStore.getByKey('proposal-export-fixed-number-of-contacts')),
    designationLimit: Number(DNAStore.getByKey('proposal-max-designations')),
    standardFieldsConfig: DNAStore.getByKeyWithDefault({
      key: 'proposal_standard_fields_config',
      options: {
        max_length: (a, b) => a < b,
      },
    }),
  };
};

const useProposalFormFluxStore = () => {
  const dnaValues = useFluxStore(DNAStore, DNAStoreMapState);
  const featureValues = useFluxStore(FeatureStore, featureStoreMapState);

  return {
    ...dnaValues,
    ...featureValues,
  };
};

export default useProposalFormFluxStore;
